import { RecipeIngredientSpecificPropertieResponse } from '@/types/response'
import Unit from "@/model/Unit";

export default class RecipeIngredientSpecificPropertie {
  private constructor (
        readonly id: string | null,
        readonly name: string,
        readonly unitId: string,
        readonly order: number,
        readonly unit: Unit | undefined
  ) {}

  public static createFromResponseList (response: RecipeIngredientSpecificPropertieResponse[]): RecipeIngredientSpecificPropertie[] {
      return response.map((item: RecipeIngredientSpecificPropertieResponse) => {
          return new RecipeIngredientSpecificPropertie(
              item.id,
              item.name,
              item.unitId,
              item.order,
              Unit.createFromResponse(item.unit)
          )
      })
  }

    public static createFromResponse (response: RecipeIngredientSpecificPropertieResponse): RecipeIngredientSpecificPropertie {
        return new RecipeIngredientSpecificPropertie(
            response.id,
            response.name,
            response.unitId,
            response.order,
            Unit.createFromResponse(response.unit)
        )
    }
}
